const MealPlanAssignOption = {
  NEW_MEAL_PLAN: 'NEW_MEAL_PLAN',
  USE_PREVIOUS_MEAL_PLAN: 'USE_PREVIOUS_MEAL_PLAN',
};

export {
  MealPlanAssignOption,
};
